import { decode } from "blurhash";

/** Soft punch: blurhash lib ignores fractional punch (`n|1`). */
function applySoftPunch(
  data: Uint8ClampedArray,
  punch: number,
): Uint8ClampedArray {
  const p = Math.max(0.05, Math.min(2, punch));
  if (Math.abs(p - 1) < 0.01) return data;
  let r = 0;
  let g = 0;
  let b = 0;
  const n = data.length / 4;
  for (let i = 0; i < data.length; i += 4) {
    r += data[i];
    g += data[i + 1];
    b += data[i + 2];
  }
  r /= n;
  g /= n;
  b /= n;
  const out = new Uint8ClampedArray(data.length);
  for (let i = 0; i < data.length; i += 4) {
    out[i] = Math.min(255, Math.max(0, r + (data[i] - r) * p));
    out[i + 1] = Math.min(255, Math.max(0, g + (data[i + 1] - g) * p));
    out[i + 2] = Math.min(255, Math.max(0, b + (data[i + 2] - b) * p));
    out[i + 3] = data[i + 3];
  }
  return out;
}

/**
 * Decode blurhash → data URL (PNG). Soft punch ~0.85 for gentler placeholders.
 */
export function blurHashToDataUrl(
  hash: string,
  width = 32,
  height = 32,
  punch = 0.85,
): string | null {
  const h = String(hash || "").trim();
  if (h.length < 6) return null;
  try {
    let pixels = decode(h, width, height, 1);
    pixels = applySoftPunch(pixels, punch);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const imageData = ctx.createImageData(width, height);
    imageData.data.set(pixels);
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL("image/png");
  } catch {
    return null;
  }
}
